import { deviceManager } from '@hid/device/device_manager'
import {
  DefineDevice,
  JingTaiMg75Devices,
  KK,
  VirtualMu68_ULTRA,
  VirtualMu68Pro,
  VirtualMu68Pro_Cyan,
  VirtualNa87ProWired,
  VirtualNd63,
  VirtualNd63_Cyan,
  VirtualPolar75,
  JingTaiMer68Devices,
  VirtualIrokFe87V2IMC,
  VirtualIrokFe87V2IMC_24g,
  VirtualMer68SESelfDev,
} from './define'

// mkey -> kk
const Mu68ProMatrix: { [index: number]: number } = {
  0x15: 0x29,
  0x16: 0x1e,
  0x17: 0x1f,
  0x18: 0x20,
  0x19: 0x21,
  0x1a: 0x22,
  0x1b: 0x23,
  0x1c: 0x24,
  0x1d: 0x25,
  0x1e: 0x26,
  0x1f: 0x27,
  0x20: 0x2d,
  0x21: 0x2e,
  0x22: 0x2a,
  0x23: 0x49, //第一行

  0x2a: 0x2b,
  0x2b: 0x14,
  0x2c: 0x1a,
  0x2d: 0x8,
  0x2e: 0x15,
  0x2f: 0x17,
  0x30: 0x1c,
  0x31: 0x18,
  0x32: 0x0c,
  0x33: 0x12,
  0x34: 0x13,
  0x35: 0x2f,
  0x36: 0x30,
  0x37: 0x31,
  0x38: 0x4c, //第二行

  0x5d: 0x39,
  0x5e: 0x04,
  0x5f: 0x16,
  0x60: 0x07,
  0x61: 0x09,
  0x62: 0x0a,
  0x63: 0x0b,
  0x64: 0x0d,
  0x65: 0x0e,
  0x66: 0x0f,
  0x67: 0x33,
  0x68: 0x34,
  0x6a: 0x28,
  0x6b: 0x4b, // 第三行

  0x72: 0xe1,
  0x74: 0x1d,
  0x75: 0x1b,
  0x76: 0x06,
  0x77: 0x19,
  0x78: 0x05,
  0x79: 0x11,
  0x7a: 0x10,
  0x7b: 0x36,
  0x7c: 0x37,
  0x7d: 0x38,
  0x7e: 0xe5,
  0x7f: 0x52,
  0x80: 0x4e, //第四行

  0x87: 0xe0,
  0x88: 0xe3,
  0x89: 0xe2,
  0x8d: 0x2c,
  0x90: 0xe6,
  0x91: 0x01,
  0x92: 0xe4,
  0x93: 0x50,
  0x94: 0x51,
  0x95: 0x4f,
}
// mkey -> kk
const Na87ProMatrix: { [index: number]: number } = {
  0x00: 0x29,
  0x01: 0x3a,
  0x02: 0x3b,
  0x03: 0x3c,
  0x04: 0x3d,
  0x05: 0x3e,
  0x06: 0x3f,
  0x07: 0x40,
  0x08: 0x41,
  0x09: 0x42,
  0x0a: 0x43,
  0x0b: 0x44,
  0x0c: 0x45,

  0x0e: 0x46,
  0x0f: 0x47,
  0x10: 0x48, // 第一行

  0x15: 0x35,
  0x16: 0x1e,
  0x17: 0x1f,
  0x18: 0x20,
  0x19: 0x21,
  0x1a: 0x22,
  0x1b: 0x23,
  0x1c: 0x24,
  0x1d: 0x25,
  0x1e: 0x26,
  0x1f: 0x27,
  0x20: 0x2d,
  0x21: 0x2e,
  0x22: 0x2a,

  0x23: 0x49,
  0x24: 0x4a,
  0x25: 0x4b, // 第二行

  0x2a: 0x2b,
  0x2b: 0x14,
  0x2c: 0x1a,
  0x2d: 0x8,
  0x2e: 0x15,
  0x2f: 0x17,
  0x30: 0x1c,
  0x31: 0x18,
  0x32: 0x0c,
  0x33: 0x12,
  0x34: 0x13,
  0x35: 0x2f,
  0x36: 0x30,
  0x37: 0x31,

  0x38: 0x4c,
  0x39: 0x4d,
  0x3a: 0x4e, // 第三行

  0x5d: 0x39,
  0x5e: 0x04,
  0x5f: 0x16,
  0x60: 0x07,
  0x61: 0x09,
  0x62: 0x0a,
  0x63: 0x0b,
  0x64: 0x0d,
  0x65: 0x0e,
  0x66: 0x0f,
  0x67: 0x33,
  0x68: 0x34,
  0x6a: 0x28,
  0x72: 0xe1,
  0x74: 0x1d,
  0x75: 0x1b,
  0x76: 0x06,
  0x77: 0x19,
  0x78: 0x05,
  0x79: 0x11,
  0x7a: 0x10,
  0x7b: 0x36,
  0x7c: 0x37,
  0x7d: 0x38,
  0x7f: 0xe5,

  0x81: 0x52, // 第四五行

  0x87: 0xe0,
  0x88: 0xe3,
  0x89: 0xe2,
  0x8d: 0x2c,
  0x91: 0xe6,
  0x92: 0x01,
  0x93: 0x65,
  0x94: 0xe4,
  0x95: 0x50,
  0x96: 0x51,
  0x97: 0x4f,
}
const ND63Matrix: { [index: number]: number } = {
  ...Mu68ProMatrix,
  0x80: 0x63,
}

const Mu68ULTRAMatrix: { [index: number]: number } = {
  ...Mu68ProMatrix,

  0x7d: 0x38,
  0x7f: 0xe5,
  0x80: 0x52,
  0x81: 0x4e, //第四行

  0x91: 0xe6,
  0x92: 0x01,
  0x93: 0xe4,
  0x94: 0x50,
  0x95: 0x51,
  0x96: 0x4f,
}

const POLAR75Matrix: { [index: number]: number } = {
  ...Na87ProMatrix,
  0x0d: 0x46,
  0x0e: 0x4c,
  0x38: 0x4b,
  0x6b: 0x4e,
  0x80: 0x52,
  0x94: 0x51,
  0x95: 0x4f,
  0x93: 0x50,
}
const Mer68Matrix: { [index: number]: number } = {
  ...Mu68ProMatrix,
  // 0x23: 0x4a,
}

const IrokFe87V2ProMatrix: { [index: number]: number } = {
  0x2c: 0x22,
  0x5e: 0x31,
  0x5f: 0x32,
  0x60: 0x33,
  0x72: 0x40,
  0x87: 0x50,
  0x8d: 0x53,
}

const Mer68SESelfDevMatrix: { [index: number]: number } = {
  0x15: 0x00,
  0x16: 0x01,
  0x17: 0x02,
  0x18: 0x03,
  0x19: 0x04,
  0x1a: 0x05,
  0x1b: 0x06,
  0x1c: 0x07,
  0x1d: 0x08,
  0x1e: 0x09,
  0x1f: 0x0a,
  0x20: 0x0b,
  0x21: 0x0c,
  0x22: 0x0d,
  0x23: 0x0e,
  0x2a: 0x0f,
  0x2b: 0x10,
  0x2c: 0x11,
  0x2d: 0x12,
  0x2e: 0x13,
  0x2f: 0x14,
  0x30: 0x15,
  0x31: 0x16,
  0x32: 0x17,
  0x33: 0x18,
  0x34: 0x19,
  0x35: 0x1a,
  0x36: 0x1b,
  0x37: 0x1c,
  0x38: 0x1d,
  0x5d: 0x1e,
  0x5e: 0x1f,
  0x5f: 0x20,
  0x60: 0x21,
  0x61: 0x22,
  0x62: 0x23,
  0x63: 0x24,
  0x64: 0x25,
  0x65: 0x26,
  0x66: 0x27,
  0x67: 0x28,
  0x68: 0x29,
  0x6a: 0x2a,
  0x6b: 0x2b,
  0x72: 0x2d,
  0x74: 0x2e,
  0x75: 0x2f,
  0x76: 0x30,
  0x77: 0x31,
  0x78: 0x32,
  0x79: 0x33,
  0x7a: 0x34,
  0x7b: 0x35,
  0x7c: 0x36,
  0x7d: 0x37,
  0x7e: 0x38,
  0x7f: 0x39,
  0x80: 0x3a,
  0x87: 0x3c,
  0x88: 0x3d,
  0x89: 0x3e,
  0x8d: 0x41,
  0x90: 0x44,
  0x91: 0x45,
  0x92: 0x46,
  0x93: 0x47,
  0x94: 0x48,
  0x95: 0x49,
}

const deviceMatrixMap: { [key: DefineDevice]: { [martrixKey: number]: number } } = {
  [VirtualNa87ProWired]: Na87ProMatrix,
  [VirtualMu68Pro]: Mu68ProMatrix,
  [VirtualNd63]: ND63Matrix,
  [VirtualNd63_Cyan]: ND63Matrix,
  [VirtualMu68Pro_Cyan]: Mu68ProMatrix,
  [VirtualMu68_ULTRA]: Mu68ULTRAMatrix,
  [VirtualPolar75]: POLAR75Matrix,
  [VirtualMer68SESelfDev]: Mer68SESelfDevMatrix,
  [VirtualIrokFe87V2IMC]: IrokFe87V2ProMatrix,
  [VirtualIrokFe87V2IMC_24g]: IrokFe87V2ProMatrix,
}
JingTaiMg75Devices.forEach((device) => {
  deviceMatrixMap[device] = POLAR75Matrix
})
JingTaiMer68Devices.forEach((device) => {
  deviceMatrixMap[device] = Mer68Matrix
})
export const KKFromMatrix = (matrixKey: number): KK => {
  // return martrixKey as KK;
  return (deviceMatrixMap[deviceManager.deviceID][matrixKey] as KK) || (matrixKey as KK)
}
